import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { GameStateService } from '../../../../services/game-state/game-state.service';
import { GameUiService } from '../../../../services/game-ui/game-ui.service';
import { GameState } from '../../../../services/game-ui/game-state.enum';
import { SignialsService } from '../../../../services/signals/signials.service';
import { AudioService } from '../../../../services/audio/audio.service';
import { ResultService } from '../../../../services/http/result/result.service';
import { AuthService } from '../../../../services/http/auth/auth.service';
import { SPINE_KEYS } from '../../../../constants/textures';
import { Container, Graphics } from 'pixi.js';
import { Spine } from '@esotericsoftware/spine-pixi-v8';
import { isMobile } from '../../../../classes/common/helpers';
import { GameContext } from '../../../../services/game-ui/game-context.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { MetrikaService } from '../../../../services/metrika.service';

export interface TestInfo {
  title: string;
  name?: string;
  value?: string;
  color?: string;
  img?: string;
  imgFull?: string;
  completed?: boolean;
}
@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrl: './resume.component.scss'
})
export class ResumeComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output()
  close: EventEmitter<void> = new EventEmitter();

  tests: TestInfo[];

  profs: TestInfo[];

  cards: TestInfo[];

  // showHelp = false;

  segments = 0;

  showDownloadBtn = false;
  showDownloadModal = false;
  isDownloading = false;
  isActive = false;
  container = new Container();

  gender = '';
  private resizeHandler: (() => void) | null = null;


  activeTab: number = 1;
  infoActive = false;
  shareActive = false;

  showModal = false;
  currentPart = 2;
  constructor(
    private state: GameStateService,
    private cdr: ChangeDetectorRef,
    private ui: GameUiService,
    private auth: AuthService,
    private audio: AudioService,
    private resultService: ResultService,
    private metrika: MetrikaService
  ) {}

  ngOnInit(): void {
    this.gender = this.gender = localStorage.getItem('gender') || '';
    this.segments = this.state.getCompletedAttractionsCount();

    this.state.progressBar.hide();
    this.showDownloadBtn = typeof this.auth.getAccessToken() === 'string';
    const status = this.state.getGameStatus('attractions');

    this.isActive = Object.keys(status || {}).length > 0;
    this.tests = [
      {
        title: 'Тип личности',
        name: status?.freid?.result?.title,
        value: status?.freid?.result?.resume ?? 'Не определен',
        color: '#ED3E1F',
        img: 'type.png',
        imgFull: 'type-full.png',
        completed: !!status?.freid?.result?.resume,
      },
      {
        title: 'Мотивация',
        name: status?.rider?.result?.title,
        value: status?.rider?.result?.resume ?? 'Не определена',
        color: '#FF6A00',
        img: 'm.png',
        imgFull: 'm-full.png',
        completed: !!status?.rider?.result?.resume,
      },
      {
        title: 'Основной интерес',
        name: status?.koldunGrey?.result?.title,
        value: status?.koldunGrey?.result?.resume ?? 'Не определен',
        color: '#008C91',
        img: 'int.png',
        imgFull: 'int-full.png',
        completed: !!status?.koldunGrey?.result?.resume,
      },
    ];
    this.cards  = [
      {
        title: 'Страхи',
        value: status?.witch?.completed ? 'Справился со страхами' : 'Не открыты',
        color: '#CC17B2',
        img: 'f.png',
        imgFull: 'f-full.png',
        completed: !!status?.witch?.completed,
      },
      {
        title: 'Мифы',
        value: status?.mirrors?.completed ? 'Развеял мифы' : 'Не открыты',
        color: '#0092FF',
        img: 'myth.png',
        imgFull: 'myth-full.png',
        completed: !!status?.mirrors?.completed,
      },
      {
        title: 'Знания',
        value: status?.magician?.completed ? 'Получил новые знания' : 'Не открыты',
        color: '#6824D4',
        img: 'kn.png',
        imgFull: 'kn-full.png',
        completed: !!status?.magician?.completed,
      },
      {
        title: 'Близкие',
        value: status?.silach?.completed ? 'Получил поддержку' : 'Не открыты',
        color: '#DF2C27',
        img: 'b.png',
        imgFull: 'b-full.png',
        completed: !!status?.silach?.completed,
      }
    ];
    this.profs = [
      {
        title: 'Основная профессия',
        value: status?.robin?.result ?? 'Не определена',
        color: '#1E40EA',
        img: 'prof.png',
        imgFull: 'prof-full.png',
        completed: !!status?.robin?.completed,
      },
      {
        title: 'Микс профессий',
        value: status?.koldunPurple?.result ?? 'Не определен',
        color: '#008C91',
        img: 'mix-prof.png',
        imgFull: 'mix-prof-full.png',
        completed: !!status?.koldunPurple?.completed,
      }
    ];
    this.ui.setState(GameState.Resume);
    // this.showHelp = !localStorage.getItem('showHelp');
    this.cdr.detectChanges();
  }
  ngAfterViewInit(): void {
    this.audio.playResume();

    if (!(this.ui.isContext(GameContext.Start) || this.ui.isContext(GameContext.Final))) return;

    const texture = this.state.resourses.getSpineData(SPINE_KEYS.cardGlow);
    if (texture) {
      const overlay = new Graphics()
      .rect(0, 0, window.innerWidth, window.innerHeight)
      .fill({ color: 0x000000, alpha: 0.3 });
      
      const spine = Spine.from({skeleton:`${SPINE_KEYS.cardGlow}_skeleton`, atlas: `${SPINE_KEYS.cardGlow}_atlas`});
      spine.state.setAnimation(0, 'appear', false);
      
      const spineW = 1385;
      const updateSize = () => {
        overlay.clear()
        .rect(0, 0, window.innerWidth, window.innerHeight)
        .fill({ color: 0x000000, alpha: 0.3 });
        
        const resume = document.getElementById('resumeModal');
        const resumeRect = resume?.getBoundingClientRect();
        spine.scale.x = spine.scale.y = resumeRect!.width * 3 / spineW;
        spine.x = window.innerWidth / 2;
        spine.y = window.innerHeight / 2;
      };
      
      updateSize();
      
      spine.zIndex = 1000;
      this.container.addChild(overlay, spine);
      this.state.app.stage.addChild(this.container);
      
      setTimeout(() => {
        spine.state.setAnimation(0, 'idle', true);
      }, 1000);
      this.resizeHandler = updateSize;
      window.addEventListener('resize', this.resizeHandler);
    }
  }
  ngOnDestroy(): void {
    this.ui.setState(GameState.Default);
    
    this.state.app.stage.removeChild(this.container);
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
    
    this.state.progressBar.show();
  }
  playBtnClick() {
    this.audio.playClickSmallBtn();
  }
  closeModal() {
    this.showModal = false;
  }

  // hideHelp() {
  //   this.showHelp = false;
  //   localStorage.setItem('showHelp', 'show');
  //   this.cdr.detectChanges();
  // }
  closeNote() {
  }

  download() {
    this.isDownloading = true;
    this.cdr.detectChanges();
    this.resultService.downloadResultPdf().subscribe({
      next: (response) => {
        this.isDownloading = false;
        this.cdr.detectChanges();



        const isIOS =
          /iPad|iPhone|iPod/.test(navigator.userAgent) ||
          (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);



        if (this.resultService.isIOSDevice() && this.resultService.getBlobForIOS()) {
          this.showDownloadModal = true;
          this.cdr.detectChanges();
        } else {
					this.state.metrika.reachGoal('career_id_download');
        }

      },
      error: (e: HttpErrorResponse) => {
        this.isDownloading = false;
        const backendMessage =
          e.error?.message ||
          e.error?.error ||
          e.message ||
          'Неизвестная ошибка';

        alert(`Произошла ошибка (${e.status || e.error.code}): ${backendMessage}`);

        this.cdr.detectChanges();}
    });
  }
  downloadFile() {
    const blob = this.resultService.getBlobForIOS();
    if (!blob) {this.hideModal(); return;}

    const pdfBlob = new Blob([blob], { type: 'application/pdf' });
    const url = URL.createObjectURL(pdfBlob);

    const newWindow = window.open('', '_blank');

    if (newWindow) {
      newWindow.location.href = url;
    } else {
      window.location.href = url;
    }
    this.state.metrika.reachGoal('career_id_download');

    setTimeout(() => URL.revokeObjectURL(url), 10000);

    this.hideModal();
  }

  hideModal() {
    this.showDownloadModal = false;
    this.cdr.detectChanges();
  }


  setTabActive(tab: number) {
    this.audio.playClickBtn();
    this.infoActive = false;
    this.shareActive = false;
    this.activeTab = tab;
    this.cdr.detectChanges();
  }

  showInfo() {
    this.shareActive = false;
    this.infoActive = true;
    this.cdr.detectChanges();
  }
  toggleInfo() {
    this.shareActive = false;
    this.infoActive = !this.infoActive;
    this.audio.playClickBtn();
    this.cdr.detectChanges();
  }
  hideInfo() {
    this.infoActive = false;
    this.cdr.detectChanges();
  }
  
  showShare() {
    this.infoActive = false;
    this.shareActive = true;
    this.audio.playClickBtn();
    this.cdr.detectChanges();
  }
  hideShare() {
    this.shareActive = false;
    this.cdr.detectChanges();
  }

  reachGoal() {
    this.metrika.reachGoal('career_id_close');
  }

  async copyCurrentLink(): Promise<void> {
    this.state.metrika.reachGoal('game_share', {share_type: 'link'});
    await navigator.clipboard.writeText('Я прошёл Career Park и получил свой Career ID.\nПройди игру и выбери профессию по-новому\ncareerpark.ru/park1/');
  }

  shareToTelegram(): void {
    this.state.metrika.reachGoal('game_share', {share_type: 'telegram'});
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent('Я прошёл Career Park и получил свой Career ID.\nПройди игру и выбери профессию по-новому');

    window.open(
      `https://t.me/share/url?text=${text}&url=${url}`,
      '_blank',
      'noopener,noreferrer'
    );
  }

  shareToVk(): void {
    this.state.metrika.reachGoal('game_share', {share_type: 'vk'});
    const url = encodeURIComponent(window.location.href);
    const title = encodeURIComponent('Я прошёл Career Park и получил свой Career ID.\nПройди игру и выбери профессию по-новому');

    window.open(
      `https://vk.com/share.php?url=${url}&title=${title}`,
      '_blank',
      'noopener,noreferrer'
    );
  }
  openSubsModal(sendMetrika?: boolean, currentPart?: number): void {
    if (sendMetrika) {
      this.metrika.reachGoal('part2_subscribe');
    }
    // window.open(
    //   'https://t.me/careerpark_start_bot',
    //   '_blank',
    //   'noopener,noreferrer'
    // );
    this.currentPart = currentPart ?? this.currentPart;
    this.showModal = true;
  }
}
